const defaultHooks = {
  onRefreshFailed: undefined,
  onRequestError: undefined,
}

let hooks = { ...defaultHooks }

export function resetAuthPolicyHooks() {
  hooks = { ...defaultHooks }
}

export async function runAuthPolicyHook(name, context) {
  const hook = hooks?.[name]
  if (typeof hook !== 'function') {
    return
  }
  try {
    await hook(context)
  } catch (error) {
    console.error(`[auth/policy] ${name} hook failed`, error)
  }
}

export function setAuthPolicyHooks(partialHooks = {}) {
  hooks = {
    ...hooks,
    ...(partialHooks || {}),
  }
}
